import React from 'react'
import { Link } from 'react-router-dom'
import { FileText, ArrowLeft } from 'lucide-react'
import TermsContent from '@/content/legal/TermsContent'

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
          <div className="flex items-center gap-2 text-gray-400 text-sm">
            <img src="https://raw.githubusercontent.com/ruxo-rod/logos/main/logo%20IA.jpg" alt="InnovaAgent" className="h-8 w-8 rounded-lg" />
            <span>InnovaAgent</span>
          </div>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <div className="flex items-center gap-3 mb-8 pb-6 border-b">
            <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
              <FileText className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Términos y Condiciones</h1>
              <p className="text-sm text-gray-500">InnovaAgent · innovagent.tech</p>
            </div>
          </div>
          <TermsContent />
          <div className="mt-8 pt-6 border-t text-center">
            <p className="text-sm text-gray-500">
              ¿Tienes dudas?{' '}
              <a href="mailto:contacto@bdctech.com.mx" className="text-blue-600 hover:underline">
                contacto@bdctech.com.mx
              </a>
            </p>
            <p className="text-xs text-gray-400 mt-2">
              Consulta también nuestro{' '}
              <Link to="/privacy" className="text-blue-500 hover:underline">Aviso de Privacidad</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsPage
